<!-- #29 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Client Pickup Slot
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-row>
      <v-col cols="8">
        <v-card class="mt-2">
          <v-card-title>
            <span class="body-1 font-weight-bold">
              {{ $route.params.id == 0 ? "Add" : "Edit" }}
              <i class="caption red--text ml-4"> * required field</i>
            </span>
            <v-spacer></v-spacer>
            <span class="caption" style="color: green">
              Note: Pickup Slot Date Time is based on Pickup Address
              Country</span
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="4" v-if="userCategory.user_category == 3">
                  <v-autocomplete
                    v-model="client"
                    :items="clients"
                    outlined
                    chips
                    item-text="name"
                    item-value="id"
                    small-chips
                    hide-details="auto"
                    label="Select Client"
                    :rules="[(v) => !!v || 'Client is required.']"
                    @change="getAddress(), upcomingSlot()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-autocomplete
                    v-model="client_address_id"
                    :items="addresses"
                    :item-text="
                      (item) =>
                        `${item.street_address},${item.address_area}, ${item.city}, ${item.country_name}, ${item.zip_code}`
                    "
                    item-value="id"
                    class="required"
                    label="Address"
                    :rules="[
                      (v) =>
                        (v !== null && v !== undefined && v !== '') ||
                        'Address is required.',
                    ]"
                    outlined
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="getFormattedDate(from_date)"
                        label="Pickup Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        hide-details="auto"
                        outlined
                        class="required"
                        :rules="[(v) => !!v || 'Pickup Date is required.']"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="from_date"
                      @input="
                        dateMenu = false;
                        updateMintime();
                      "
                      :min="getStartDate"
                      :max="getEndDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-autocomplete
                    v-model="selectedSlot"
                    :items="slotsArr"
                    outlined
                    hide-details="auto"
                    label="Select Pickup Slot"
                    class="required"
                    :rules="[(v) => !!v || 'Pickup Slot is required.']"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-autocomplete
                    v-model="tracking_id_type"
                    :items="types"
                    item-text="text"
                    item-value="value"
                    class="required"
                    label="Tracking ID Type"
                    :rules="[
                      (v) =>
                        (v !== null && v !== undefined && v !== '') ||
                        'Tracking ID Type is required.',
                    ]"
                    outlined
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="notes"
                    label="Notes/Comments"
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-file-input
                    v-if="$route.params.id > 0"
                    v-model="data_file"
                    label="Upload file"
                    clearable
                    accept=".xlsx"
                    outlined
                    hide-details="auto"
                    prepend-icon=""
                    prepend-inner-icon="mdi-paperclip"
                    @click="data_file = null"
                    class="pb-4"
                  >
                  </v-file-input>
                  <v-file-input
                    v-else
                    v-model="data_file"
                    label="Upload file"
                    clearable
                    accept=".xlsx"
                    class="required pb-0"
                    :rules="[(v) => !!v || 'File is required.']"
                    outlined
                    prepend-icon=""
                    prepend-inner-icon="mdi-paperclip"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <v-btn
                color="primary"
                @click="save()"
                :loading="saveLoader"
                dark
                v-if="$route.params.id > 0"
                class="mt-0"
              >
                Update
              </v-btn>
              <v-btn
                color="primary"
                @click="save()"
                :loading="saveLoader"
                dark
                class="mt-0"
                v-else
              >
                save
              </v-btn>
              <v-btn
                color="primary"
                @click="downloadTemplate()"
                dark
                class="info mt-0 mr-2 ml-4"
                v-if="client"
              >
                Download Template
              </v-btn>
              <v-btn class="ml-3 mt-0" color="white" @click="closeFun">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                @click="addAddress()"
                dark
                v-if="client"
                class="info mt-0 mr-2 ml-4"
              >
                Add Address
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4" class="pl-2">
        <v-card class="mt-2">
          <v-card-title>
            <span class="body-1 font-weight-bold">
              Available Carrier Slots
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="tableData"
            class="elevation-1 pl-0"
            disable-pagination
            hide-default-footer
          >
            <v-divider class="mt-1 mb-4"></v-divider>
            <template v-slot:item.days="{ item }">
              <span v-html="item.days"></span>
            </template>
            <template v-slot:item.courierName="{ item }">
              {{ capitalizeFirstLetter(item.courierName) }}
            </template>
            <template v-slot:item.country="{ item }">
              {{ capitalizeFirstLetter(item.country) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      max-width="650px"
      @keydown.esc="close"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >Add Pickup Address
            <i class="caption red--text ml-4"> * required field</i></span
          >
        </v-card-title>
        <v-divider class="mt-3"></v-divider>

        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    v-model="editedAddress.address_type"
                    label="Address Type"
                    :rules="[
                      (v) => (v !== '' && v !== null) || 'Type is required.',
                    ]"
                    class="required pb-0"
                    outlined
                    :items="addressTypes"
                    hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedAddress.street_address"
                    label="Address Line1"
                    :rules="[
                      (v) => (v && !!v.trim()) || 'Address Line1 is required.',
                    ]"
                    outlined
                    class="required pb-0"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedAddress.address_area"
                    label="Address Line2"
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </v-col>

                <!-- <v-col cols="12" sm="6" md="6">
                      <v-text-field
                      
                        v-model="editedAddress.city_name"
                        label="City"
                        :rules="[
                          (v) => (v && !!v.trim()) || 'City name is required.',
                        ]"
                        class="required"
                      ></v-text-field>
                    </v-col>
                     -->
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    label="Country"
                    :items="allCountries"
                    item-text="name"
                    item-value="code"
                    @input="cityList(editedAddress.country_code)"
                    v-model="editedAddress.country_code"
                    :rules="[(v) => !!v || 'Country is required']"
                    class="required pb-0"
                    hide-details="auto"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    label="City"
                    :items="citiesList"
                    item-text="name"
                    item-value="name"
                    v-model="editedAddress.city_name"
                    :rules="[(v) => !!v || 'City is required']"
                    class="required pb-0"
                    :loading="cityLoader"
                    hide-details="auto"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedAddress.zip_code"
                    label="Pincode / Zipcode"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedAddress.phone_number"
                    hide-details="auto"
                    label="Phone Number"
                    :rules="[
                      (v) => (v && !!v.trim()) || 'Phone number is required.',
                    ]"
                    class="required pb-0"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedAddress.email"
                    label="Email Id"
                    hide-details="auto"
                    outlined
                    :rules="[
                      (v) =>
                        !v ||
                        /.+@.+\..+/.test(v) ||
                        'E-mail address must be valid',
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-switch
                    v-model="editedAddress.address_status"
                    hide-details="auto"
                    label="Status"
                    outlined
                  ></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            @click="saveAdd"
            :loading="saveAddressLoader"
            class="ml-6"
          >
            {{ editedIndex === -1 ? "Add" : "Update" }}
          </v-btn>
          <v-btn color="primary" @click="close" class="error"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSlot"
      max-width="450px"
      @keydown.esc="close"
      persistent
    >
      <v-card>
        <v-card-title class="subtitle pl-4"
          >Are you sure you want to update this slot?</v-card-title
        >
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary darken-1" @click="dialogSlot = false">No</v-btn>
          <v-btn color="success darken-1" @click="uploadResFun">Yes</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
    <BulkErrors
      :dialog="uploadResDialogConfirm"
      :data="uploadResConfirm"
      @close="(uploadResDialogConfirm = false), (dialogSlot = true)"
    />
    <BulkErrors
      :dialog="uploadResDialogError"
      :data="uploadResError"
      @close="uploadResDialogError = false"
    />
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BulkErrors from "@/components/front/common/BulkNew";

export default {
  components: {
    BulkErrors,
  },
  computed: {
    ...mapGetters(["userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 10);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    inactiveStyle() {
      // Calculate the width of the inactive region
      const inactiveWidth = (this.mintime / 1440) * 100;
      return {
        position: "absolute",
        left: "0",
        top: "50%",
        transform: "translateY(-50%)",
        height: "8px",
        width: `${inactiveWidth}%`,
        background: "#ccc", // Inactive area color
        zIndex: "-1",
      };
    },
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },
    dynamicMinTime() {
      const today = this.formatDate(new Date());
      if (this.selectedDate === today) {
        const currentTime = new Date();
        const currentMinutes =
          currentTime.getHours() * 60 + currentTime.getMinutes();
        return Math.min(currentMinutes + 60, 1440); // Ensure it doesn't exceed 1440 minutes
      }
      return 0; // Default minimum time for non-today dates
    },
    formattedTime() {
      return this.formatTime(this.time);
    },
  },
  data() {
    return {
      uploadResDialogError: false,
      uploadResError: null,
      selectedSlot: null,
      slotsArr: ["08:00 to 11:00", "11:00 to 14:00", "14:00 to 20:00"],
      saveAddressLoader: false,
      dialogSlot: false,
      uploadResDialog: false,
      uploadResConfirm: null,
      mintime: 0,
      addresses: [],
      dialog: false,
      types: [
        {
          text: "RSA Tracking No",
          value: "rsa_tracking_no",
        },
      ],
      addressTypes: [
        {
          text: "Pickup",
          value: 4,
        },
      ],
      editedAddress: {
        address_type: 4,
        street_address: "",
        address_area: "",
        area_name: "",
        city_name: "",
        state: "",
        country_code: "",
        zip_code: "",
        phone_number: "",
        email: "",
        address_status: true,
      },

      tracking_id_type: "rsa_tracking_no",
      client_address_id: null,
      data_file: null,
      client: null,
      start_slot_time: null,
      options: {},
      from_date: "",
      to_date: "",
      menuTime: false,
      menuTimeTo: false,
      uploadResDialogConfirm: false,
      dateMenu: false,
      dateMenuTo: false,
      slotList: [],
      editedIndex: -1,
      loader: false,
      statusLoader: false,
      status: null,
      carrierId: null,
      total: 0,
      cityLoader: false,
      timeSlots: [],
      clients: [],
      schedule_date: null,
      end_slot_time: null,
      notes: "",
      time: 0,
      uploadRes: null,
      saveLoader: false,
      citiesList: [],
      allCountries: [],
      tableData: [],
      headers: [
        {
          text: "Carrier Name",
          value: "courierName",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Country",
          value: "country",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Days",
          value: "days",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
    };
  },
  async created() {
    this.updateMintime();
    // Ensure slider starts at the minimum time
    this.time = this.mintime;
    if (this.$store.getters.user.user_category == 1) {
      this.client = this.$store.getters.user.id;
      this.getAddress();
      this.upcomingSlot();
    } else {
      await this.fetchClients();
    }
    if (this.$route.params.id > 0) {
      this.callApi(this.$route.params.id);
    }
  },
  watch: {
    mintime(newMintime) {
      if (this.time < newMintime) {
        this.time = newMintime;
      }
    },
  },
  methods: {
    ...mapActions([
      "downloadClientSlotTemplate",
      "snackBar",
      "fetchClient",
      "getClientSlotAddresses",
      "updateClientSlot",
      "getClientSlotRecord",
      "fetchCityList",
      "getCountries",
      "createClientAddress",
      "addClientPickupSlot",
      "confirmUpdateClientSlot",
      "getCLientUpcomingSLot",
    ]),
    handleSliderInput(value) {
      // Prevent scrolling below mintime
      if (value < this.mintime) {
        this.time = this.mintime;
      } else {
        this.time = value;
      }
    },
    updateMintime() {
      const now = new Date();
      const today = now.toISOString().split("T")[0];
      const selectedDate = this.from_date; // Replace with the selected date logic
      if (today === selectedDate) {
        const currentMinutes = now.getHours() * 60 + now.getMinutes();
        this.mintime = Math.min(currentMinutes + 60, 1440); // Set mintime to current time + 1 hour
      } else {
        this.mintime = 0; // Default to start of the day
      }
    },

    formatTime(value) {
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
    },
    closeFun() {
      this.$router.replace({
        name: "ClientSlot",
      });
    },
    saveAdd() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveAddressLoader = true;
      this.createClientAddress({
        id: this.client,
        params: this.editedAddress,
      })
        .then((res) => {
          this.saveAddressLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialog = false;
          this.getAddress();
        })
        .catch(() => {
          this.saveAddressLoader = false;
        });
    },
    close() {
      this.dialog = false;
      this.editedAddress = {};
      this.editedIndex = -1;
      this.$refs.form?.reset();
    },
    async getCountryList() {
      await this.getCountries().then((res) => {
        this.allCountries = res.data;
      });
    },
    fetchClients() {
      if (this.clients.length == 0)
        this.fetchClient({
          service: "clickdna,fulfillment_wid_last_mile",
        }).then((res) => {
          this.clients = res.data;
        });
    },
    addAddress() {
      this.getCountryList();
      this.dialog = true;
    },
    cityList(value) {
      this.cityLoader = true;
      this.fetchCityList(value).then((res) => {
        this.citiesList = res.data;
        this.cityLoader = false;
      });
    },
    downloadTemplate() {
      let id;
      if (this.$route.params.id > 0) {
        id = this.$route.params.id;
      } else {
        id = 0;
      }
      let payload = {
        client_id: this.client,
        client_pickup_id: id,
      };
      this.downloadClientSlotTemplate(payload)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    getAddress() {
      this.country_id = null;
      this.addresses = [];
      if (this.client) {
        this.getClientSlotAddresses(this.client).then((res) => {
          this.addresses = res.data;
        });
      }
    },
    transformData(apiResponse) {
      const tableData = [];
      for (const courier in apiResponse.slot_data) {
        const daysOfWeek = [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ];
        for (const country in apiResponse.slot_data[courier]) {
          const daysInfo = apiResponse.slot_data[courier][country];
          const days = daysOfWeek
            .map((day) => {
              const slots = daysInfo[day] || [];
              if (slots.length === 0) return null;
              const slotsInfo = slots
                .map((slot) => {
                  const scheduleDate = slot.schedule_date
                    ? `(${slot.schedule_date}) `
                    : "";
                  const start_slot_time = slot.start_slot_time
                    ? `${scheduleDate}${slot.start_slot_time} to ${slot.end_slot_time}`
                    : scheduleDate;
                  if (slot.slot_type === "public_holiday") {
                    return `<span style="color: red">${start_slot_time} (Public Holiday)</span>`.trim();
                  }
                  return start_slot_time.trim();
                })
                .filter(Boolean)
                .join(", ");
              return `${day} - ${slotsInfo}`;
            })
            .filter(Boolean)
            .join("<br>"); // Add line breaks for each day

          tableData.push({
            courierName: courier,
            country: country,
            days: days, // Use formatted string with <br>
          });
        }
      }
      this.tableData = tableData;
    },
    upcomingSlot() {
      if (this.client) {
        this.getCLientUpcomingSLot(this.client).then((res) => {
          this.upcomingSlots = res.data.slot_data;
          this.transformData(res.data);
        });
      }
    },
    callApi(id) {
      this.getClientSlotRecord(id).then(async (res) => {
        if (this.$store.getters.user.user_category !== 1) {
          await this.fetchClients();
        }
        this.client = res.data.records[0].client_id;
        this.upcomingSlot();
        this.status = res.data.records[0].status;
        this.tracking_id_type = res.data.records[0].tracking_id_type;
        this.start_slot_time = res.data.records[0].pickup_time_from;
        this.end_slot_time = res.data.records[0].pickup_time_to;
        this.from_date = res.data.records[0].pickup_date;
        this.client_address_id = res.data.records[0].client_address_id;
        this.notes = res.data.records[0].notes;
        this.selectedSlot = `${this.start_slot_time} to ${this.end_slot_time}`;
        await this.getAddress();
      });
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const payload = new FormData();
      let [startTime, endTime] = this.selectedSlot.split(" to");

      payload.append("pickup_time_from", `${startTime}:00`);
      payload.append("pickup_time_to", `${endTime.trim()}:00`);

      payload.append("pickup_date", this.from_date);
      payload.append("client_address_id", this.client_address_id);

      payload.append("tracking_id_type", this.tracking_id_type);

      payload.append("client_id", this.client);
      payload.append("notes", this.notes);
      if (this.data_file) {
        payload.append("data_file", this.data_file, this.data_file.name);
      }
      this.saveLoader = true;
      if (this.status == false) {
        this.status = 0;
      } else {
        this.status = 1;
      }
      if (this.$route.params.id > 0) {
        payload.append("client_pickup_id", this.$route.params.id);
        payload.append("status", this.status);

        let data = {
          data: payload,
          client_id: this.client,
        };
        payload.append("is_confirmation", "True");

        this.confirmUpdateClientSlot(data)
          .then((res) => {
            if (res.data.no_update == true && res.data.with_error) {
              this.saveLoader = false;
              this.saveLoader = false;
              this.uploadResError = res.data;
              this.uploadResDialogError = true;

              // this.$router.push("/client-slot");
              return;
            }
            this.saveLoader = false;
            this.uploadResConfirm = res.data;
            this.uploadResConfirm.messageText = "Updated Successfully.";

            this.uploadResDialogConfirm = true;
            payload.delete("is_confirmation");
          })
          .catch(() => {
            this.saveLoader = false;
          });
      } else {
        let [startTime, endTime] = this.selectedSlot.split(" to");

        payload.append("pickup_time_from", `${startTime}:00`);
        payload.append("pickup_time_to", `${endTime.trim()}:00`);

        this.addClientPickupSlot(payload)
          .then((res) => {
            this.saveLoader = false;
            this.uploadRes = res.data;
            this.uploadRes.messageText = "Added Successfully.";

            this.uploadResDialog = true;
            // this.$router.replace({
            //   name: "ClientSlot",
            // });
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },

    uploadResFun() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.dialogSlot = false;
      const payload = new FormData();

      let [startTime, endTime] = this.selectedSlot.split(" to");

      payload.append("pickup_time_from", `${startTime}:00`);
      payload.append("pickup_time_to", `${endTime.trim()}:00`);
      payload.append("pickup_date", this.from_date);
      payload.append("client_address_id", this.client_address_id);
      payload.append("tracking_id_type", this.tracking_id_type);
      payload.append("client_id", this.client);
      payload.append("notes", this.notes);
      if (this.data_file) {
        payload.append("data_file", this.data_file, this.data_file.name);
      }
      this.saveLoader = true;
      if (this.status == false) {
        this.status = 0;
      } else {
        this.status = 1;
      }
      if (this.$route.params.id > 0) {
        payload.append("client_pickup_id", this.$route.params.id);
        payload.append("status", this.status);

        let data = {
          data: payload,
          client_id: this.client,
        };
        this.updateClientSlot(data)
          .then((res) => {
            this.saveLoader = false;
            // this.$router.replace({
            //   name: "ClientSlot",
            // });
            this.uploadRes = res.data;
            this.uploadResDialog = true;
            // this.snackBar({
            //   color: "success",
            //   message: res.data.message,
            // });
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
  },
};
</script>
<style>
::v-deep .v-slider__track {
  height: 12px; /* Make the track taller */
}
::v-deep .v-slider__thumb {
  width: 24px; /* Increase thumb size */
  height: 24px; /* Increase thumb size */
  margin-top: -6px; /* Adjust thumb vertical position */
}

/* Style for the slider inactive area */
.slider-inactive {
  position: absolute;
  height: 12px; /* Match the track height */
  background-color: #ccc; /* Inactive slider background */
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
</style>
